import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  icon?: ReactNode;
}

/** Meaningful empty state: what is missing, and the one action that fixes it. */
export const EmptyState = ({ title, description, action, icon }: EmptyStateProps) => (
  <div className="flex flex-col items-center justify-center gap-2 px-6 py-14 text-center">
    {icon ? <div className="mb-1 text-ink-subtle">{icon}</div> : null}
    <p className="text-[14px] font-medium text-ink">{title}</p>
    {description ? <p className="max-w-md text-[13px] text-ink-muted">{description}</p> : null}
    {action ? <div className="mt-3">{action}</div> : null}
  </div>
);
